import gql from 'graphql-tag';
import { NormalizedCacheObject } from '@apollo/client';
export class RequestLineInput {
  id: number;
  aa: number;
  notes: string;
  collectionPointRequestId: number;
  containerTypeId: number;
  quantity: number;

  constructor() {
    this.id = undefined;
    this.aa = undefined;
    this.notes = undefined;
    this.collectionPointRequestId = undefined;
    this.containerTypeId = undefined;
    this.quantity = undefined;
  }
}
export class FormInput {
  id: number;
  name: string;
  professionId: number;
  addressLine1: string;
  addressArea: string;
  addressNomos: string;
  postalCode: string;
  addressCity: string;
  phoneNumber1: string;
  phoneNumber2: string;
  companyVat: string;
  companyTaxOffice: string;
  contactPerson: string;
  email: string;
  notes: string;
  isApproved: boolean;
  judgeNotes: string;
  judgedByUser: string;
  judgeDate: Date;
  collectionpointId: number;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;
  requestLines: RequestLineInput[];

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.professionId = undefined;
    this.addressLine1 = undefined;
    this.addressArea = undefined;
    this.addressNomos = undefined;
    this.postalCode = undefined;
    this.addressCity = undefined;
    this.phoneNumber1 = undefined;
    this.phoneNumber2 = undefined;
    this.companyVat = undefined;
    this.companyTaxOffice = undefined;
    this.contactPerson = undefined;
    this.email = undefined;
    this.notes = undefined;
    this.isApproved = undefined;
    this.judgeNotes = undefined;
    this.judgedByUser = undefined;
    this.judgeDate = undefined;
    this.collectionpointId = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
    this.requestLines = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollectionpointRequests($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionpointRequests(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        professionId
        addressLine1
        addressArea
        postalCode
        addressCity
        addressNomos
        phoneNumber1
        phoneNumber2
        companyVat
        companyTaxOffice
        contactPerson
        email
        notes
        isApproved
        judgeNotes
        judgedByUser
        judgeDate
        collectionpointId
        requestLines {
          id
          aa
          notes
          collectionPointRequestId
          containerTypeId
          containertype {
            id
            name
          }
          quantity
        }
        firstDate
        lastDate
        firstUser
        lastUser
        profession {
          id
          name
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCollectionpointRequestById($id: Int) {
    getCollectionpointRequestById(id: $id) {
      id
      name
      professionId
      addressLine1
      addressArea
      addressNomos
      postalCode
      addressCity
      phoneNumber1
      phoneNumber2
      companyVat
      companyTaxOffice
      contactPerson
      email
      notes
      isApproved
      judgeNotes
      judgedByUser
      judgeDate
      collectionpointId
      firstDate
      lastDate
      firstUser
      lastUser
      profession {
        id
        name
      }
      collectionpoint {
        id
        name
      }
      requestLines {
        id
        aa
        notes
        collectionPointRequestId
        containerTypeId
        containertype {
          id
          name
        }
        quantity
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollectionpointRequest($data: CollectionpointRequestInput) {
    addCollectionpointRequest(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollectionpointRequest($data: CollectionpointRequestInput) {
    updateCollectionpointRequest(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollectionpointRequest($id: Int) {
    deleteCollectionpointRequest(id: $id)
  }
`;

///judgeFlow
export const GET_DUPLICATE_COLLECTION_POINTS = gql`
  query getDuplicateCollectionPoints($name: String!, $companyVat: String!, $postalCode: String!) {
    collectionPoints(
      where: {
        name: { eq: $name }
        companyVat: { eq: $companyVat }
        postalCode: { eq: $postalCode }
      }
    ) {
      id
      name
      companyVat
      postalCode
      address
    }
  }
`;

export const ACCEPT_COLLECTION_POINT_REQUEST = gql`
  mutation acceptCollectionpointRequest($id: Int!, $collectionpointId: Int) {
    acceptCollectionpointRequest(id: $id, collectionpointId: $collectionpointId) {
      id
    }
  }
`;

export const REJECT_COLLECTION_POINT_REQUEST = gql`
  mutation rejectCollectionpointRequest(
    $id: Int!
    $reason: String!
    $judgedByUser: String
    $judgeDate: DateTime
  ) {
    rejectCollectionPointRequest(
      data: {
        id: $id
        isApproved: false
        judgeNotes: $reason
        judgedByUser: $judgedByUser
        judgeDate: $judgeDate
        # optionally also set judgeDate, judgedByUser, etc.
      }
    ) {
      id
      isApproved
      judgeNotes
    }
  }
`;
export async function findSimilarCollectionPoints({
  client,
  name,
  companyVat,
  postalCode,
}: {
  client: any;
  name: string;
  companyVat: string;
  postalCode: string;
}): Promise<any> {
  const gqlScript = gql`
    query getCollectionpoints($where: String) {
      getCollectionpoints(where: $where) {
        data {
          id
          name
          postalCode
          companyVat
        }
        recordCount
      }
    }
  `;
  const where = {
    $and: [{ name }, { companyVat }, { postalCode }],
  };
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getCollectionpoints;
}
//delete collectionPointRequestLine
export const DELETE_COLLECTION_POINT_REQUEST_LINE = gql`
  mutation deleteCollectionpointrequestline($id: Int) {
    deleteCollectionpointrequestline(id: $id)
  }
`;
